import React from 'react';
import { MAIN_CONTENT_ID } from '../constants/a11y';

// WCAG 2.4.1 bypass block: the first tab stop on every page. Invisible until it has
// keyboard focus, then pinned at z-[9999]: above the sidebar (z-40/50), Modal and
// WorkspaceDialog (z-50), the upgrade prompt and toasts (z-[60]). Only ConfirmModal, which is
// also z-[9999] and later in the DOM, paints over it, and that dialog owns the keyboard anyway.
//
// A plain `#main-content` hash navigation would work in a static page, but here
// BrowserRouter listens to popstate: changing the hash would push a history entry (and
// make Back appear to do nothing). So the click is intercepted and focus is moved by
// hand; the href stays as the no-JS / assistive-tech fallback and for "copy link address".
const SkipLink = () => {
  const handleClick = event => {
    event.preventDefault();
    document.getElementById(MAIN_CONTENT_ID)?.focus();
  };

  return (
    <a
      href={`#${MAIN_CONTENT_ID}`}
      onClick={handleClick}
      className="sr-only focus:not-sr-only focus:fixed focus:top-2 focus:left-2 focus:z-[9999] focus:px-4 focus:py-2 focus:rounded-lg focus:bg-white focus:text-lavender-700 focus:font-semibold focus:shadow-lg focus:ring-2 focus:ring-lavender-500 focus:outline-hidden dark:focus:bg-gray-800 dark:focus:text-lavender-200"
    >
      Skip to main content
    </a>
  );
};

export default SkipLink;
